// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
// import ProductListActions from "@insite/content-library/Widgets/ProductList/ProductListActions"; // Store Custom Code

import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

/* Valtech Custom Code */
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import getColor from "@insite/mobius/utilities/getColor";
import { productCardProps } from "@store/Themes/common/props/productCard";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Valtech Custom Code */

// import ProductListProductImage, {
//     ProductListProductImageStyles,
// } from "@insite/content-library/Widgets/ProductList/ProductListProductImage"; // Bunzl Custom Code
import { imageStyles } from "@store/Themes/common/mixins/image";

/* Bunzl Custom Code Start */
import ProductListProductInformation from "@store/Library/Widgets/ProductList/ProductListProductInformation";
import ProductListProductImage, {
    ProductListProductImageStyles,
} from "@store/Overrides/Widgets/ProductList/ProductListProductImage";
/* Bunzl Custom Code End */

/* Store Custom Code - Start */
import ProductListActions from "@store/Overrides/Widgets/ProductList/ProductListActions";
/* Store Custom Code - End */

type Props = ProductCardSelections &
    // Bunzl custom code
    HasProduct & { enableImageHover?: boolean; transitionDuration?: number; transitionTimingFunction?: string };

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    // Bunzl custom code -->
    extendedProductImageStyles?: ProductListProductImageStyles;
    bottomSectionWrapper?: InjectableCss;
    // Bunzl custom code <--
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    // bunzl custom code -->
    bottomSectionWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            height: 100%;
            gap: ${({ theme }) => theme.design.layout.spacing.smaller};
        `,
    },
    wrapper: productCardProps.card,
    extendedProductImageStyles: {
        productImage: {
            wrapper: {
                css: css``,
            },
            linkWrappingImage: {
                css: css`
                    /* theme styles are assuming that the image is a 285px square and was spacing accordingly while the actual card is a rectangle of around these dimensions */
                    ${imageStyles(177 / 285)}
                `,
            },
        },
    },
    // bunzl custom code <--
    imageWrapper: productCardProps.image?.wrapper,
    sponsoredText: {
        css: css`
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            font-size: ${x => x.theme.design.typography.size.tiny};
            padding: 0.5em 1em;
            border: ${pxToRem(1)} solid ${getColor("common.border")};
            border-top: 0;
            border-left: 0;
            background: ${getColor("common.background")};
            color: ${getColor("text.accent")};
        `,
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    /* Bunzl Custom Code Start */
    transitionDuration,
    transitionTimingFunction,
    enableImageHover,
    /* Bunzl Custom Code  End */
}) => {
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            {showImage /* Valtech Custom Code */ ? (
                <StyledWrapper {...styles.imageWrapper}>
                    {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                    {/* Bunzl Custom Code added extended styles */}
                    <ProductListProductImage
                        extendedStyles={styles.extendedProductImageStyles}
                        showImage={showImage}
                        showCompare={false}
                        /* Bunzl Custom Code Start */
                        transitionDuration={transitionDuration}
                        transitionTimingFunction={transitionTimingFunction}
                        enableImageHover={enableImageHover}
                        /* Bunzl Custom Code End */
                    />
                </StyledWrapper>
            ) : null}
            <StyledWrapper {...styles.bottomSectionWrapper}>
                {" "}
                {/* Bunzl Custom Code */}
                <ProductListProductInformation
                    showAttributes={showAttributes}
                    showAvailability={showAvailability}
                    showBrand={showBrand}
                    showPartNumbers={showPartNumbers}
                    showTitle={showTitle}
                    showImageBadges={showImageBadges}
                    maxImageBadges={maximumNumberOfImageBadges}
                    showTextBadges={showTextBadges}
                    maxTextBadges={maximumNumberOfTextBadges}
                />
                <ProductListActions showAddToList={showAddToList} showPrice={showPrice} />
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductGridCard);
